import React, { useEffect, useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Button, Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { openDialog } from "state/slices/DialogSlice";
import { useTypedDispatch, useTypedSelector } from "hooks/store";

import "./ChangePatient.scss";

import PatientPositionItem from "../PatientPosition/PatientPositionItem";

const DialogSaveModelContent = (): JSX.Element => {
    const dispatch = useTypedDispatch();
    const type = useTypedSelector((store) => store.Dialog.type);

    const handleDialogClose = (): void => {
        dispatch(openDialog({ isDialogOpen: false, type }));
    };

    const availablePositions = useTypedSelector((store) => store.Scene.availablePatientPosition);

    const [gender, setGender] = useState<"male" | "female" | "child">("male");
    const [filteredResult, setFilteredResult] = useState([{}]);

    useEffect(() => {
        const pos = availablePositions.filter((data) => data.gender === gender);
        setFilteredResult(pos);
    }, [gender, availablePositions]);

    const handleGenderChange = (
        event: React.MouseEvent<HTMLElement>,
        newGender: "male" | "female" | "child" | null
    ) => {
        if (newGender !== null) {
            setGender(newGender);
        }
    };

    return (
        <>
            <DialogActions className="cmrDialogActionContainer">
                <Button
                    startIcon={<CloseOutlinedIcon />}
                    fullWidth
                    onClick={handleDialogClose}
                    className="btn grayRoundedButton"
                >
                    Cancel
                </Button>
            </DialogActions>
            <DialogContent>
                <section>
                    <Grid container>
                        <Grid item xs={12} className="heading">
                            <h2 style={{ marginBottom: "30px" }}>Select patient&apos;s position</h2>
                        </Grid>
                        <Grid item xs={12}>
                            <ToggleButtonGroup
                                value={gender}
                                exclusive
                                onChange={handleGenderChange}
                                aria-label="patient gender"
                                size="small"
                                sx={{ marginBottom: "20px" }}
                            >
                                <ToggleButton value="male" color="primary">
                                    Male
                                </ToggleButton>
                                <ToggleButton value="female" color="primary">
                                    Female
                                </ToggleButton>
                                <ToggleButton value="child" color="primary">
                                    Child
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                    </Grid>
                    <div className="patient-container">
                        <Grid container spacing={2}>
                            {filteredResult.map((position, i) => {
                                return (
                                    <>
                                        <Grid item xs={4} key={i}>
                                            <PatientPositionItem item={position} />
                                        </Grid>
                                    </>
                                );
                            })}
                        </Grid>
                    </div>
                </section>
            </DialogContent>
        </>
    );
};

export default DialogSaveModelContent;
